import React from 'react';
import { motion } from 'framer-motion';
import { Flame } from 'lucide-react';
export function Mechanism() {
  return <section className="py-14 md:py-16 bg-brand-navy text-white relative overflow-hidden" data-id="element-155">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 -mt-20 -mr-20 w-96 h-96 bg-brand-gold/10 rounded-full blur-3xl" data-id="element-156"></div>
      <div className="absolute bottom-0 left-0 -mb-20 -ml-20 w-80 h-80 bg-brand-green/10 rounded-full blur-3xl" data-id="element-157"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl relative z-10 text-center" data-id="element-158">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-159">
          <div className="inline-flex items-center justify-center p-3 bg-brand-gold/20 rounded-full mb-8" data-id="element-160">
            <Flame className="w-8 h-8 text-brand-gold" data-id="element-161" />
          </div>

          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 text-brand-cream leading-tight" data-id="element-162">
            Presentamos el{' '}
            <span className="text-brand-gold" data-id="element-163">Método Fuego Cero</span>
          </h2>

          <p className="text-xl md:text-2xl text-brand-cream/90 font-medium mb-8 leading-relaxed" data-id="element-164">
            Un sistema diseñado específicamente para el metabolismo de la mujer
            chilena de +40.
          </p>

          <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 rounded-2xl" data-id="element-165">
            <p className="text-lg text-brand-cream/80 leading-relaxed" data-id="element-166">
              No es una dieta restrictiva, es un protocolo de "extinción" que
              utiliza ingredientes locales (Líder/Jumbo/Feria) para apagar la
              inflamación celular en 15 minutos o menos, estabilizando tus
              hormonas sin estrés.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}